import type { App, InjectionKey } from 'vue'
import type { ApiClient } from './types'

export interface CreateApiClientPluginOptions {
  client: ApiClient
  provideKey?: string | symbol | InjectionKey<ApiClient>
  propertyName?: string
}

export const createApiClientPlugin = (options: CreateApiClientPluginOptions) => {
  const injectionKey: InjectionKey<ApiClient> = (
    typeof options.provideKey === 'string'
      ? Symbol.for(options.provideKey)
      : options.provideKey
  ) ?? Symbol.for('space.api-client')

  const propertyName = options.propertyName ?? '$api'

  return {
    install(app: App) {
      app.provide(injectionKey, options.client)
      Object.defineProperty(app.config.globalProperties, propertyName, {
        get() {
          return options.client
        },
      })
    },
    injectionKey,
  }
}


